<template>
  <div
    v-if="pax && pax['covid19_portal'] && checkBoardingProcess() && paxBoarding && !paxBoarding.boarded_status"
    class="boarding-plane"
  >
    <div class="bachgroup-drop"></div>
    <div class="popup-boarding-process container mt-5">
      <h3 class="mb-2 board-text">{{ boarding_text }}</h3>
      <h2 v-if="!boarding_now && pause <= 0" class="mb-1 mt-5 time-board">{{ getTimeBoarding() }}</h2>
      <button
        v-if="boarding_now && pause <= 0"
        type="button"
        class="btn btn-lg btn-primary col-12 mt-2 mb-2 border-radius-25"
        @click="confirmBoarding()"
      >
        {{ pax['covid19_portal'][7]['BOARDED'] }}
      </button>
      <br />
      <h3>{{ pax.first_name }} {{ pax.last_name }}</h3>
    </div>
  </div>
</template>
<script>
import '@/assets/scss/modules/BoardingPlane.scss'
import Socketclient from '@/assets/plugin/socket-client'
import moment from 'moment'
const CHANNEL_BOARDING_PROCESS = 'boarding-process'
export default {
  name: 'BoardingPlane',
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      paxBoarding: null,
      countDown: 0,
      pause: 0,
      boarding_text: '',
      boarding_now: false,
      start_count_down: 0,
      running_socket: 0,
      socketClient: {}
    }
  },
  watch: {
    start_count_down: function () {
      if (this.start_count_down) {
        this.countDownTimer()
      }
    }
  },
  created() {
    let self = this
    if (self.pax === undefined || self.pax === null) {
      this.$store.dispatch('getPax')
    }
    self.getBoardingInfo()

    this.socketClient = new Socketclient({
      subscribeKey: process.env.VUE_APP_SOCKET_SUBSCRIBE_KEY,
      socketDomain: process.env.VUE_APP_SOCKET_DOMAIN
    })
  },
  mounted() {
    let self = this
    self.socketClient.subscribe({ channels: [CHANNEL_BOARDING_PROCESS] })

    self.socketClient.addListener('message', function (data) {
      switch (data.channel) {
        case CHANNEL_BOARDING_PROCESS:
          if (data.data.flightBoarding == self.pax.flight_id) {
            if (self.running_socket == 0) {
              self.running_socket = 1
              self.getBoardingInfo()
            }
          }
          break
        default:
      }
    })
  },
  methods: {
    checkBoardingProcess() {
      let self = this
      if (self.pause > 0) {
        self.boarding_text = self.pax['covid19_portal'][7]['PAUSED_BOARD']
      } else {
        if (self.countDown >= 15) {
          self.boarding_text = self.pax['covid19_portal'][7]['WAITING_CALL']
        } else if (self.countDown <= 0) {
          self.boarding_text = self.pax['covid19_portal'][7]['CALLED_BOARD_2']
        } else {
          self.boarding_text = self.pax['covid19_portal'][7]['CALLED_BOARD']
        }
      }
      this.boarding_now = self.countDown <= 0 ? true : false
      return true
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          if (this.pause > 0) {
            this.pause -= 1
          }
          this.countDown -= 1
          this.countDownTimer()
        }, 1000)
      } else {
        this.start_count_down = 0
      }
    },
    getTimeBoarding() {
      var sec_num = this.countDown // don't forget the second param
      var hours = Math.floor(sec_num / 3600)
      var minutes = Math.floor((sec_num - hours * 3600) / 60)
      var seconds = sec_num - hours * 3600 - minutes * 60

      if (hours < 10) {
        hours = hours <= 0 ? 0 : '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      return (hours == 0 ? '' : hours + ':') + minutes + ':' + seconds
    },
    calculateTimeBoarding() {
      let now = moment.utc()
      var timeStart = moment.utc(this.paxBoarding.start_boarding_at)
      var timePause = moment.utc(this.paxBoarding.pause_boarding_at)
      let diffStart = now.diff(timeStart, 'seconds')
      let diffPause = now.diff(timePause, 'seconds')
      let timeWait = this.paxBoarding.time_wait_boarding - diffStart > 0 ? this.paxBoarding.time_wait_boarding - diffStart : 0
      this.pause = this.paxBoarding.time_pause - diffPause > 0 ? this.paxBoarding.time_pause - diffPause : 0
      this.countDown = timeWait + this.pause + this.paxBoarding.time_pause_total
    },
    confirmBoarding() {
      this.$store
        .dispatch('updateStatusBoarding', {
          boarded_status: 1
        })
        .then((response) => {
          if (response.success) {
            this.paxBoarding.boarded_status = 1
          }
        })
    },
    getBoardingInfo() {
      let self = this
      self.$store.dispatch('getPaxBoarding').then((response) => {
        self.running_socket = 0
        if (response?.success) {
          self.paxBoarding = response.data
          self.calculateTimeBoarding()
          self.start_count_down = 1
        }
      })
    }
  }
}
</script>
